import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";

import { UserService } from "@core/http/serviceIndex";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { User } from "@models/CommonModel";
import { forkJoin } from "rxjs";
import { DetailService } from "@app/core/http/detail.service";

@Component({
  selector: "main-dashboard",
  templateUrl: "./main-dashboard.component.html",
  styleUrls: ["./main-dashboard.component.css"],
})
export class MainDashboardComponent implements OnInit {
  public branchList: any = [];
  public prictiseType: any;
  public eligibleLists: any;
  modalRef: any;
  validProfile: boolean = false;
  loginForm: FormGroup;
  createUserForm: FormGroup;
  submitted = false;
  submitModel = false;
  public isError: boolean = false;
  public errorMsg: any;
  public isGuest: boolean = false;
  //password-show/hide
  fieldTextType: boolean;
  repeatFieldTextType: boolean;
  loading = false;
  public scoreList: any = [];
  public isProgress: boolean = false;

  constructor(
    private modalService: NgbModal,
    private formBuilder: FormBuilder,
    private router: Router,
    private _service: UserService,
    private _detailService: DetailService
  ) { }

  ngOnInit() {
    // if(localStorage.getItem('userData'))
    //   this.router.navigateByUrl('alchemist-academy/home')
    // else
    this.loginForm = this.formBuilder.group({
      email: ["", [Validators.required, Validators.email]],
      password: ["", [Validators.required, Validators.minLength(6)]],
    });

  }



  toggleFieldTextType() {
    this.fieldTextType = !this.fieldTextType;
  }

  toggleRepeatFieldTextType() {
    this.repeatFieldTextType = !this.repeatFieldTextType;
  }
  // convenience getter for easy access to form fields

  openModal(content, type) {
    let branch = this._detailService.getAllBranch();
    let desirescore = this._detailService.getdesiredScore();
    forkJoin([branch, desirescore]).subscribe((res) => {
      this.branchList = res[0].branchList;
      this.scoreList = res[1];
      this.createUserForm = this.formBuilder.group({
        mail: ["", [Validators.required, Validators.email]],
        fullName: ["", [Validators.required]],
        gender: ["MALE", [Validators.required]],
        branch: ["", [Validators.required]],
        phoneNumber: [""],
        desireScore: [""],
      });
      this.submitModel = false;
      this.prictiseType = type;
      this.modalRef = this.modalService.open(content, {
        size: "l",
        centered: true,
      });
    })

  }

  onCreate() {
    this.isProgress = true;
    this.submitModel = true;

    // stop here if form is invalid
    if (this.createUserForm.invalid) {
      this.isProgress = false;
      return;
    } else {
      this.isProgress = true;
      const newUser = new User();
      newUser.fullName = this.createUserForm.get("fullName").value;
      newUser.email = this.createUserForm.get("mail").value;
      newUser.gender = this.createUserForm.get("gender").value;
      newUser.branch = this.createUserForm.get("branch").value;
      newUser.mobilePhone = this.createUserForm.get("phoneNumber").value;
      // this.router.navigateByUrl("/home");
      this.isGuest = true;
      this._service.register(newUser, this.isGuest).subscribe(() => {
        this.router.navigateByUrl("/");
        this.createUserForm = this.formBuilder.group({
          mail: ["", [Validators.required, Validators.email]],
          fullName: ["", [Validators.required]],
          gender: ["MALE", [Validators.required]],
          branch: ["", [Validators.required]],
          phoneNumber: [""],
          desireScore: [""],
        });
        this.isProgress = false;

      }, err => {
        this.isProgress = false;
        this.isError = true;
        this.errorMsg = err;
      }
      );
      this.modalRef.close();
    
    }
  }

  get f() {
    return this.loginForm.controls;
  }
  get g() {
    return this.createUserForm.controls;
  }
  getAllBranch() {
    this._detailService.getAllBranch().subscribe(
      (res: any) => {
        this.branchList = res.branchList;
      });
  }
  close() {
    this.isProgress = false;
    this.modalRef.close();
    this.createUserForm = this.formBuilder.group({
      mail: ["", [Validators.required, Validators.email]],
      fullName: ["", [Validators.required]],
      gender: ["MALE", [Validators.required]],
      branch: ["", [Validators.required]],
    });
  }

  onLogin() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.loginForm.invalid) {
      return;
    } else {
      this.isProgress = true;
      // this.loading = true;
      this._service.login(this.loginForm.value).subscribe(
        (res) => {
          localStorage.setItem("token", res.token);
          localStorage.setItem("userData", btoa(JSON.stringify(res.user)));
          this.router.navigateByUrl("/alchemist-academy/home");
        },
        (err) => {
          this.isProgress = false;
          this.isError = true;
          this.errorMsg = err;
        }
      );
    }
  }
}
